import { MapPin, Navigation, Phone } from "lucide-react";

/**
 * The identity block under the cover: whether it's open, the name, where it is,
 * a few facts at a glance, and the two things a visitor most often wants.
 */
export default function DetailSummary({
  title,
  status,
  address,
  tags = [],
  description,
  onDirections,
  directionsLabel,
  phone,
  callLabel,
  share,
}) {
  const actionBase =
    "inline-flex h-12 min-w-0 items-center justify-center gap-2 rounded-[2px] px-3 text-[12px] font-bold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#171717] focus-visible:ring-offset-2 dark:focus-visible:ring-white";
  const actionDark =
    actionBase + " bg-[#171717] text-white hover:bg-[#33332f] dark:bg-[#f2efe9] dark:text-[#171614] dark:hover:bg-white";

  return (
    <div className="mt-5">
      {status}

      <h1 className="mt-2 text-[clamp(31px,6vw,47px)] font-extrabold leading-[1.035] tracking-[-.05em] text-[#171717] dark:text-[#f6f3ed]">
        {title}
      </h1>

      {address && (
        <p className="mt-1.5 flex items-start gap-1.5 text-[13px] leading-5 text-[#6d6d6a] dark:text-[#b8b3a9]">
          <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0" strokeWidth={2} />
          <span className="min-w-0">{address}</span>
        </p>
      )}

      {tags.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1.5">
          {tags.map((tag) => (
            <span
              key={tag}
              className="rounded-[2px] border border-[#e3dfd7] bg-[#f7f5f1] px-2.5 py-1 text-[10px] font-semibold text-[#48453f] dark:border-white/15 dark:bg-white/[0.07] dark:text-[#d8d3ca]"
            >
              {tag}
            </span>
          ))}
        </div>
      )}

      {description && (
        <p className="mt-4 line-clamp-3 max-w-[62ch] text-[14px] leading-[1.7] text-[#55554f] dark:text-[#c5c1b8]">{description}</p>
      )}

      <div className="mt-4 grid grid-cols-2 gap-2">
        <button type="button" onClick={onDirections} className={actionDark}>
          <Navigation className="h-4 w-4 shrink-0" strokeWidth={2} />
          <span className="truncate">{directionsLabel}</span>
        </button>
        {phone ? (
          <a href={"tel:" + phone} className={actionDark}>
            <Phone className="h-4 w-4 shrink-0" strokeWidth={2} />
            <span className="truncate">{callLabel}</span>
          </a>
        ) : (
          share
        )}
      </div>
    </div>
  );
}